import React from 'react';

import './Poll.scss';

export default function Poll(props) {
  const { item, username, addSurveyAnswer } = props;

  if (!item || !item.question) return null;

  return (
    <section id="poll">
      <p id="poll_title">{item.question}</p>

      <ul id="poll_options">
        {item.options.map((option, idx) => (
          <li
            key={idx}
            data-value={option.value}
            onClick={(e) => sendAnswer(e)}
          >
            {option.label}
          </li>
        ))}
      </ul>
    </section>
  );

  function sendAnswer(e) {
    addSurveyAnswer({
      variables: {
        username,
        surveyId: +item.id,
        answer: e.target.dataset.value
      }
    });
  }
}
